var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.PanelObjMobile = new Class({
    Extends: OCS.WxBriefing.Classes.PanelObj,
    load_embeddable_url: function (data, product_info) {
        this.empty_panel(true);
    },
    get_dynamic_map_obj: function () {
        return OCS.WxBriefing.Classes.DynamicMapMobile;
    },
    set_panel_id: function (id) {
        this.panel.setProperty('id', id);
        this.on_url_state_change();
    },
    apply_panel_class: function () {
    },
});